import { useState, type FormEvent } from 'react';

const FORM_ADDR = 'https://readdy.ai/api/form/daftt59tto0ceqqnhhi0';

export default function SubmitSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('idle');
    setFormError('');

    const fd = new FormData(form);
    // 蜜罐字段：非空则不提交，直接返回成功反馈
    const honeypot = (fd.get('contact_alt') as string) || '';
    if (honeypot.trim() !== '') {
      setStatus('success');
      form.reset();
      return;
    }
    fd.delete('contact_alt');

    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (typeof value === 'string') payload.append(key, value);
    });

    try {
      const res = await fetch(FORM_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
      const detail = parsed?.meta?.detail || '';
      const serverMsg = `${msg}${detail}`.toLowerCase();
      const ok =
        res.ok &&
        (parsed?.code === 'OK' || parsed?.code === 'ok' || !parsed?.code) &&
        !serverMsg.includes('spam');

      if (ok) {
        setStatus('success');
        form.reset();
      } else {
        setFormError(parsed?.meta?.message || parsed?.meta?.detail || '提交失败，请稍后再试');
        setStatus('error');
      }
    } catch {
      setFormError('网络异常，请稍后再试');
      setStatus('error');
    }
  }

  return (
    <section id="submit" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="flex flex-col items-center gap-6 bg-gradient-to-br from-primary-600 to-primary-500 px-6 py-8 text-center md:flex-row md:justify-between md:text-left md:px-10">
            <div>
              <h2 className="font-heading text-2xl text-background-50 md:text-3xl">手上有料？前排等你来投</h2>
              <p className="mt-2 max-w-xl text-sm text-primary-100 md:text-base">
                你看到的最新动态、路透或名场面，都可以在下方表单投稿。小编会核实信源、脱敏处理后再呈现，让更多前排网友一起蹲到后续。
              </p>
            </div>
            <span className="hidden h-20 w-20 items-center justify-center rounded-full bg-background-50/15 text-5xl text-background-50 md:flex">
              <i className="ri-megaphone-fill"></i>
            </span>
          </div>

          <form data-readdy-form onSubmit={onSubmit} className="grid grid-cols-1 gap-5 p-6 md:grid-cols-2 md:p-10">
            <div className="flex flex-col gap-1.5">
              <label htmlFor="name" className="text-sm font-medium text-foreground-800">你的昵称</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="怎么称呼你"
                required
                className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="email" className="text-sm font-medium text-foreground-800">联系邮箱</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="用于后续跟进（选填）"
                className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </div>

            <div className="flex flex-col gap-1.5 md:col-span-2">
              <label htmlFor="melonsource" className="text-sm font-medium text-foreground-800">吃瓜分类</label>
              <select
                id="melonsource"
                name="melonsource"
                required
                className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              >
                <option value="娱乐圈">娱乐圈</option>
                <option value="选秀舞台">选秀舞台</option>
                <option value="商界瓜田">商界瓜田</option>
                <option value="红毯现场">红毯现场</option>
                <option value="综艺盘点">综艺盘点</option>
                <option value="考古专区">考古专区</option>
              </select>
            </div>

            <div className="flex flex-col gap-1.5 md:col-span-2">
              <label htmlFor="source" className="text-sm font-medium text-foreground-800">事件标题</label>
              <input
                id="source"
                name="source"
                type="text"
                placeholder="用一句话概括你掌握的新瓜"
                required
                className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </div>

            <div className="flex flex-col gap-1.5 md:col-span-2">
              <label htmlFor="details" className="text-sm font-medium text-foreground-800">事件详情</label>
              <textarea
                id="details"
                name="details"
                rows={5}
                maxLength={500}
                placeholder="描述事件经过、时间线与相关信源，越详细越便于核实（500 字以内）"
                className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              ></textarea>
              <div className="text-right text-xs text-foreground-400">最多 500 字</div>
            </div>

            {/* 蜜罐反垃圾字段 */}
            <input
              type="text"
              name="contact_alt"
              className="contact-honeypot"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            <div className="flex flex-col gap-3 md:col-span-2">
              {status === 'success' && (
                <div className="flex items-center gap-2 rounded-md bg-accent-100 px-4 py-3 text-sm text-accent-800">
                  <i className="ri-checkbox-circle-fill"></i>
                  投稿已收到，感谢前排分享！小编会尽快核实并跟进后续。
                </div>
              )}
              {status === 'error' && (
                <div className="flex items-center gap-2 rounded-md bg-primary-100 px-4 py-3 text-sm text-primary-700">
                  <i className="ri-error-warning-fill"></i>
                  {formError || '提交失败，请稍后再试'}
                </div>
              )}
              <button
                type="submit"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-fill"></i>
                提交爆料
              </button>
              <p className="text-center text-xs text-foreground-400">
                投稿即视为同意仅提交已公开信息，我们会对你的昵称与邮箱严格保密。
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}